module.exports = __webpack_public_path__ + "img/1.8c8454b5.png";